import JLibChartCustoms       from '../../../svgchartlib-v3/lib/Components/Z_Charts/00_Customs'
import JLibChartDonut         from '../../../svgchartlib-v3/lib/Components/Z_Charts/01_Donut'
import JLibChartPie           from '../../../svgchartlib-v3/lib/Components/Z_Charts/02_Pie'
import JLibChartBarAxis       from '../../../svgchartlib-v3/lib/Components/Z_Charts/03_Bar_Normal'
import JLibChartBarSolid      from '../../../svgchartlib-v3/lib/Components/Z_Charts/04_Bar_Solid'
import JLibChartBarProgress   from '../../../svgchartlib-v3/lib/Components/Z_Charts/00_System/Progress'
import JLibChartSummary       from '../../../svgchartlib-v3/lib/Components/Z_Charts/00_System/Summary'
import JLibChartWeekly        from '../../../svgchartlib-v3/lib/Components/Z_Charts/00_System/Week'
import JLibChartBarDelta      from '../../../svgchartlib-v3/lib/Components/Z_Charts/06_Bar_Delta'
import JLibChartHistogram     from '../../../svgchartlib-v3/lib/Components/Z_Charts/06_Histogram'
import JLibChartRadar         from '../../../svgchartlib-v3/lib/Components/Z_Charts/07_Radar'
// import JLibChartSkyline       from '../../../svgchartlib-v3/lib/Components/Z_PageComponents/03_Skylines'
// import JLibChartTableSummary  from '../../../svgchartlib-v3/lib/Components/Z_Charts/00_System/Summary_Table_Dep2'
import JLibComponentSvg       from '../../../svgchartlib-v3/lib/Components/Z_PageComponents/00_Customs'

// svg3 Demo Project
import JLibV2ComponentSvg     from '../../../svgchartlib-v3/export/Demo_index'
// svg3 Component
import JLibV2ChartCustoms     from '../../../svgchartlib-v3/export/Component_index'

export default {
  ...JLibChartCustoms,
  ...JLibV2ChartCustoms,
  JLibChartDonut,
  JLibChartPie,
  JLibChartBarAxis,
  JLibChartBarSolid,
  JLibChartBarProgress,
  JLibChartSummary,
  JLibChartWeekly,
  JLibChartBarDelta,
  JLibChartHistogram,
  JLibChartRadar,
  // JLibChartSkyline,
  // JLibChartTableSummary,
  ...JLibComponentSvg,  
  ...JLibV2ComponentSvg,
}
